import { Dispatch, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import styles from './PassportMassDeletion.module.scss';
import { ISelectOption, SelectInput } from '../../../UIPackage/MainModule/components/SelectInput';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import {
  ROUTE_PASSPORT_MASS_DELETION_GROUP_BY_ID,
  ROUTE_PASSPORT_MASS_DELETION_NEW_GROUP,
} from '../../../CorePackage/MainModule/routes/routes';
import { addNoticeAction } from '../../../CorePackage/NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from '../../../CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from '../../../CorePackage/NotificationModule/enums/MessageTypesEnum';
import {
  passportGroupGetNextPageAction,
  passportGroupGetPageAction,
  passportGroupSetNoticeAction,
} from '../../../PassportGroupPackage/MainModule/actions/passportGroupActions';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import {
  passportGroupListSelector,
  passportGroupListTotalCountSelector,
  passportGroupNoticeSelector,
} from '../../../PassportGroupPackage/MainModule/selectors/passportGroupSelector';
import { catalogForceGet } from '../../../CorePackage/CatalogsModule/actions/catalogsActions';
import { CommonCatalogsNamesEnum } from '../../../CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { PassportGroupTypeEnum } from '../../../APIPackage/PassportGroupsModule/enums/PassportGroupTypeEnum';
import { IPassportGroupShort } from '../../../APIPackage/PassportGroupsModule/interfaces/IPassportGroupShort';
import { PassportGroupStatusEnum } from '../../../APIPackage/PassportGroupsModule/enums/PassportGroupStatusEnum';
import { getPassportMassDeleteReasonSelectOptions } from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';

const canBeOpen = (group: IPassportGroupShort) => {
  return !(group.status === PassportGroupStatusEnum.WAITING_ACTION && group.processing);
};

export const PassportMassDeletion = () => {
  const history = useHistory();
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const notice = useSelector(passportGroupNoticeSelector);
  const groupList = useSelector(passportGroupListSelector);
  const totalCount = useSelector(passportGroupListTotalCountSelector);
  const reasonSelectOptions = useSelector(getPassportMassDeleteReasonSelectOptions);
  const [reasonValue, setReasonValue] = useState<ISelectOption<number> | undefined>();

  useEffect(() => {
    dispatch(catalogForceGet(CommonCatalogsNamesEnum.PASSPORT_MASS_DELETE_REASON));
    setReasonValue(undefined);
  }, [dispatch, setReasonValue]);

  useEffect(() => {
    dispatch(passportGroupGetPageAction(PassportGroupTypeEnum.DELETION, reasonValue?.id));
  }, [dispatch, reasonValue]);

  const handleNextPage = useCallback(() => {
    dispatch(passportGroupGetNextPageAction(PassportGroupTypeEnum.DELETION, reasonValue?.id));
  }, [dispatch, reasonValue]);

  const handleCreateGroup = useCallback(() => {
    history.push(ROUTE_PASSPORT_MASS_DELETION_NEW_GROUP);
  }, [history]);

  useEffect(() => {
    if (notice) {
      dispatch(
        addNoticeAction({
          renderContent: notice,
          noticeType: NoticeTypesEnum.SUCCESS,
          messageType: MessageTypesEnum.PASSPORT_GROUP,
        }),
      );
      dispatch(passportGroupSetNoticeAction(undefined));
    }
  }, [dispatch, notice]);

  return (
    <div>
      <h1 className={styles.Title}>Группа мероприятий, подлежащих удалению</h1>
      <div className={styles.FilterBlock}>
        <SelectInput
          placeholder="Для поиска выберите основание массового удаления"
          isClearable
          options={reasonSelectOptions}
          value={reasonValue}
          onChange={setReasonValue}
        />
        <Button text="Сформировать группу" type="button" color="primary" onClick={handleCreateGroup} />
      </div>
      <table className={styles.Table}>
        <thead>
          <tr className={styles.TableHeader}>
            <th>№ группы</th>
            <th>дата и время создания</th>
            <th>основания массового удаления</th>
            <th>статус</th>
            <th>всего</th>
            <th>удалено</th>
          </tr>
        </thead>
        <tbody>
          {groupList.map(item => (
            <tr key={item.id} className={styles.TableRow}>
              <td>
                {canBeOpen(item) ? (
                  <Link className="shared-table-link" to={ROUTE_PASSPORT_MASS_DELETION_GROUP_BY_ID(item.id)}>
                    {item.id}
                  </Link>
                ) : (
                  item.id
                )}
              </td>
              <td>{item.createdAt}</td>
              <td>{item.reasonName}</td>
              <td>
                {item.statusName} {item.error && '(ошибка)'}
                {!item.error && item.processing && '(в процессе)'}
              </td>
              <td>{item.totalCount}</td>
              <td>{item.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {totalCount > groupList.length && <Button text="Показать ещё" color="load" onClick={handleNextPage} />}
    </div>
  );
};
